import Form from '@/vuetify_custom/v-form'
import { VBtn } from 'vuetify/lib'
import { mapGetters } from 'vuex'

export default {
    components: {
        Form
      
      },
      data() {
        return {
          sss:{},
          obj: {
            s:'asdads',
            test1:1233,
            test2: 111,
            test5: true,
            test12: true
            // test4:1
          },
        }
      },
      watch: {
      },
      computed: {
        ...mapGetters('async', {
          analysis_leaf_titles: 'analysis_leaf_titles', // 分析
          product_teams: 'product_teams',
          analysis_leaf_titles_hash: 'analysis_leaf_titles_hash'
        }),
        obj_clone() {
            return this.obj
        },
        fields() {
          return [
            {
              type:'text_field',
              label: '测试输入框',
              key: 'test',
              cols:6,
              scopedSlots:{
                label:() => {
                  return <p>测试我们测试我们</p>
                }
              },
              rules: [
                (text) => !!text || '请输入测试内容' 
              ]
            },
            {
              type:'integer_field',
              label: '整数输入框',
              cols:6,
              key: 'test1'
            },
            {
              type:'number_field',
              label: '小数输入框',
              key: 'test2',
              d_digits:2,
            },
            {
              type:'number_field',
              label: '小数输入框',
              key: 'test3',
              d_digits:2,
            },
            {
              type: 'autocompletes',
              label: 'Autocompletes测试',
              key: 'test4',
              items:this.product_teams.filter(item => !item.del),
              'item-value':"id",
              'item-text':({full_name}) => full_name,
            },
            {
              type: 'checkbox',
              label: 'checkbox测试',
              key: 'test5',
            },
            {
              type: 'combobox',
              label: 'combobox测试',
              key: 'test6',
              multiple:true,
              items:[
                'Programming',
                'Design',
                'Vue',
                'Vuetify',
              ]
            },
            {
              type: 'overflow_buttons',
              label: 'overflow_buttons测试',
              key: 'test7',
              items:  [
                { text: '100%' },
                { text: '75%' },
                { text: '50%' },
                { text: '25%' },
                { text: '0%' },
              ],
              'item-value':'text'
            },
            {
              type: 'radio_buttons',
              label: 'radio_buttons测试',
              key: 'test9',
              items: [
                {
                  label:"red",
                  color:"red",
                  value:"red",
                },
                {
                  label:"indigo",
                  color:"indigo",
                  value:"indigo",
                },
              ]
            },
            {
              type: 'select_field',
              label: 'select测试',
              key: 'test10',
              items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
            },
            {
              type: 'slider',
              label: 'slider测试',
              key: 'test11',
              color:'orange',
            },
            {
              type: 'switch_field',
              label: 'switch测试',
              key: 'test12',
            },
            {
              type: 'date_picker',
              label: 'date_picker测试',
              key: 'test13',
            }
          ]
        },
        proxy() {
          const _this = this
          return JSON.parse(JSON.stringify(_this.obj))
        }
      },
    
    methods: {
        submit() {
            console.log(this.$refs.form)
        //   const form = this.$refs.form
        //   form.validate()
        //   console.log(form.validate())
        }
      },
    render() {
        return <div>
            {/* 作用域插槽的使用 */}
                <Form 
                    ref="form"
                    value={this.obj}
                    fields={this.fields}
                    scopedSlots={{
                      //  test: ({field}) => {
                      //      return <div>{field.label}</div>
                      //  }
                    }}
                >
                    </Form>
                    <p>测试测试</p>
                <VBtn
                    onClick={this.submit}
                >Normal</VBtn>
        </div>
    }
}